import axios, { CancelToken } from 'axios';
import uuid from 'uuid/v4';
import s3 from '../common/api/s3Api';

async function getSignedURL(fileType, filePath, acl, bucket) {
  const params = {
    bucketName: bucket,
    filePath,
    contentType: fileType,
    ACL: acl
  };
  const response = await s3.get('/getsignedurl', { params });
  return response.data.url || '/';
}

export default {
  async uploadVideo(file, vm) { // Rollback
    const acl = 'private';
    const fileType = file.type;
    const filePath = `${uuid()}-${file.name}`;
    const signedUrl = await getSignedURL(fileType, filePath, acl, process.env.UPLOAD_BUCKET_NAME);
    let index = 1;
    const getIndexForFileName = () => {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith('videoupload')) {
          index++;
        }
      });
      return index;
    };
    const fileIndex = getIndexForFileName();
    localStorage.setItem(`videoupload-${fileIndex}-${file.name}`, 0);
    const options = {
      headers: {
        'Content-Type': file.type
      },
      onUploadProgress(progressEvent) {
        vm.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        localStorage.setItem(`videoupload-${fileIndex}-${file.name}`, Math.round((progressEvent.loaded * 100) / progressEvent.total));
      },
      cancelToken: new CancelToken((cancel) => {
        vm.cancel = cancel;
      }
      )
    };
    try {
      const response = await axios.put(signedUrl, file, options);
      return response.request.responseURL.split('?').shift();
    } catch (error) {
      localStorage.setItem(`videoupload-${index}-${file.name}`, 'errored');
    }
  },

  async uploadSubtitles(file, vm, accountID) {
    const acl = 'public-read';
    const fileType = 'text/plain';
    const fileName = file.file.name.replace(/[^a-zA-Z0-9_•-]/g, '').toLowerCase();
    const language = file.language;
    const filePath = accountID ? `${accountID}/subtitles/${language}/${uuid()}-${fileName}` : `subtitles/${language}/${uuid()}-${fileName}`;
    const signedUrl = await getSignedURL(fileType, filePath, acl, process.env.SUBTITLES_BUCKET_NAME);
    const options = {
      headers: {
        'Content-Type': fileType
      },
      onUploadProgress(progressEvent) {
        vm.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      }
    };
    await axios.put(signedUrl, file.file, options);
    return filePath;
  },

  async uploadImage(file, vm, accountID) {
    const acl = 'public-read';
    const fileType = file.type;
    const fileName = file.name.replace(/\s/gi, '_').toLowerCase();
    const filePath = accountID ? `${accountID}/${uuid()}-${fileName}` : `${uuid()}-${fileName}`;
    const signedUrl = await getSignedURL(fileType, filePath, acl, process.env.IMAGES_BUCKET_NAME);
    const options = {
      headers: {
        'Content-Type': file.type
      },
      onUploadProgress(progressEvent) {
        vm.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      }
    };
    await axios.put(signedUrl, file, options);
    return filePath;
  },

  async uploadCustom(file, vm, accountID) {
    const acl = 'public-read';
    const fileType = file.type;
    const fileName = file.name.replace(/\s/gi, '_').toLowerCase();
    const filePath = accountID ? `${accountID}/custom/${uuid()}-${fileName}` : `custom/${uuid()}-${fileName}`;
    const signedUrl = await getSignedURL(fileType, filePath, acl, process.env.IMAGES_BUCKET_NAME);
    const options = {
      headers: {
        'Content-Type': file.type
      },
      onUploadProgress(progressEvent) {
        vm.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      }
    };
    await axios.put(signedUrl, file, options);
    return filePath;
  },
  async uploadHeroImage(file, vm, accountID) {
    const acl = 'public-read';
    const fileType = file.type;
    const fileName = file.name.replace(/\s/gi, '_').toLowerCase();
    const filePath = accountID ? `${accountID}/heroimage/${uuid()}-${fileName}` : `heroimage/${uuid()}-${fileName}`;
    const signedUrl = await getSignedURL(fileType, filePath, acl, process.env.IMAGES_BUCKET_NAME);
    const options = {
      headers: {
        'Content-Type': file.type
      },
      onUploadProgress(progressEvent) {
        vm.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      }
    };
    await axios.put(signedUrl, file, options);
    return filePath;
  },
  async uploadThumbnail2x3(file, vm, accountID) {
    const acl = 'public-read';
    const fileType = file.type;
    const fileName = file.name.replace(/\s/gi, '_').toLowerCase();
    const filePath = accountID ? `${accountID}/thumbnail2x3/${uuid()}-${fileName}` : `thumbnail2x3/${uuid()}-${fileName}`;
    const signedUrl = await getSignedURL(fileType, filePath, acl, process.env.IMAGES_BUCKET_NAME);
    const options = {
      headers: {
        'Content-Type': file.type
      },
      onUploadProgress(progressEvent) {
        vm.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      }
    };
    await axios.put(signedUrl, file, options);
    return filePath;
  },
  async uploadDistributionPoster(file, vm, accountID) {
    const acl = 'public-read';
    const fileType = file.type;
    const fileName = file.name.replace(/\s/gi, '_').toLowerCase();
    const filePath = accountID ? `${accountID}/distributionposter/${uuid()}-${fileName}` : `distributionposter/${uuid()}-${fileName}`;
    const signedUrl = await getSignedURL(fileType, filePath, acl, process.env.IMAGES_BUCKET_NAME);
    const options = {
      headers: {
        'Content-Type': file.type
      },
      onUploadProgress(progressEvent) {
        vm.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      }
    };
    await axios.put(signedUrl, file, options);
    return filePath;
  }
};



// WEBPACK FOOTER //
// ./src/services/uploadService.js